import { ContactItem } from 'src/app/components/user-dashboard/contacts/models/contacts';
// actions/contacts.actions.ts
import {
  createAction,
  createActionGroup,
  props,
  emptyProps,
} from '@ngrx/store';
import { CreateContactDto } from 'src/app/components/user-dashboard/contacts/create/dto/create-contact.dto';

export const ContactsActions = createActionGroup({
  source: 'Load Contacts',
  events: {
    load: emptyProps(), // Use emptyProps() for actions without props
    loadSuccess: props<{ contacts: ContactItem[] }>(),
    loadFailure: props<{ error: any }>(),
  },
});

export const NewContactActions = createActionGroup({
  source: 'Create New Contact',
  events: {
    create: props<{ createPayload: CreateContactDto }>(),
    loadSuccess: props<{ contact: ContactItem }>(),
    loadFailure: props<{ error: any }>(),
  },
});

export const UpdateContactActions = createActionGroup({
  source: 'Update Contact',
  events: {
    update: props<{
      itemId: number;
      item: Partial<CreateContactDto>;
      contactType: any;
    }>(),
    updateSuccess: props<{ contact: ContactItem }>(),
    updateFailure: props<{ error: any }>(),
  },
});

export const DeleteContactActions = createActionGroup({
  source: 'Delete Contact',
  events: {
    delete: props<{ id: number; contactType: any }>(),
    deleteSuccess: props<{ id: number }>(),
    deleteFailure: props<{ error: any }>(),
  },
});
